import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { firstValueFrom } from 'rxjs';
import { IAgendaEduAccessInfo } from '../../../../interfaces/iagenda-edu-access-info';
import { IAgendaEduLog } from '../../../../interfaces/iagenda-edu-log';
import { IFatura } from './../../../../interfaces/ifatura';
import { IFaturaDetalhada } from '../../../../interfaces/ifatura-detalhada';
import { IFaturaDetalhadaAPI } from '../../../../interfaces/ifatura-detalhada-api';
import { FaturaService } from './../../../../services/fatura.service';
import { Fatura } from './../../../../utils/fatura';
import { LogService } from './../../../../services/log.service';
import { AccessInfo } from './../../../../utils/access-info';
import { environment } from './../../../../environments/environment';

@Component({
  selector: 'app-fatura-detalhar',
  templateUrl: './fatura-detalhar.component.html',
  styleUrls: ['./fatura-detalhar.component.scss'],
})
export class FaturaDetalharComponent implements OnInit {
  showTicket: boolean = true;
  diasMaximoAtraso: number = environment.diasMaximoAtraso;
  timeElapsed: number = 3000;
  copied: boolean = false;
  urlListarFaturas: string = '';
  faturaDetalhada!: IFaturaDetalhada;
  fatura!: IFatura;

  private emptyFatura: IFatura = {
    bankSliptId: '',
    codColigada: 0,
    codFilial: 0,
    isMD: false,
    dueDate: '',
    value: 0,
    isAgreement: false,
    description: '',
    title: '',
    bankSliptUrl: '',
    bankSliptStatus: '',
    isAutoNegotiationRedirectionEnabled: false,
    isOverdue: false,
    barcode: '',
    codigoPix: ''
  };

  constructor(
    private route: ActivatedRoute,
    private faturaService: FaturaService,
    private logService: LogService
  ) {}

  ngOnInit(): void {
    const faturaId: string = this.route.snapshot.paramMap.get('id') ?? '0';
    this.prepareDetalhesFatura(faturaId);
    let accessInfo: IAgendaEduAccessInfo = AccessInfo.getAccessInfo();
    this.urlListarFaturas = `/responsavel/${accessInfo.responsibleToken}/aluno/${accessInfo.studentToken}/${accessInfo.accessToken}/fichafinanceira`;
  }

  public convertFaturaToFaturaDetalhada(fatura: IFatura): IFaturaDetalhada {
    let accessInfo: IAgendaEduAccessInfo = AccessInfo.getAccessInfo();
    let faturaDetalhada: IFaturaDetalhada = {
      faturaStatus: fatura.bankSliptStatus,
      faturaUrl: fatura.bankSliptUrl,
      description: fatura.description,
      dueDate: fatura.dueDate,
      linhaDigitavel: '',
      linhaDigitavelTratada: '',
      telefoneEscola: '',
      title: fatura.title,
      value: fatura.value,
      studentId: accessInfo.studentId,
      emailEscola: '',
      juros: 0,
      mora: 0
    };

    return faturaDetalhada;
  }

  public logCardDetail(fatura: IFatura, message: string) {
    let cardDetailLog: IAgendaEduLog = {
      responsibleToken: '',
      studentToken: '',
      message: message,
      category: Fatura.categoryAcessoFatura,
      urlOrigem: `/fatura/${fatura.bankSliptId}`,
      bankSlipAgendaEdu: fatura,
    };

    this.logService.logAgendaEdu(cardDetailLog).subscribe();
  }

  public async prepareDetalhesFatura(faturaId: string): Promise<void> {
    this.fatura = this.getFatura(faturaId);
    this.logCardDetail(
      this.fatura,
      `Acesso aos detalhes da fatura`
    );
    this.faturaDetalhada = this.convertFaturaToFaturaDetalhada(this.fatura);
    const detalhesFatura = await this.getFaturaDetails(this.fatura);
    const accessInfo = AccessInfo.getAccessInfo();
    this.faturaDetalhada = {
      description: this.fatura.description,
      dueDate: this.fatura.dueDate,
      faturaStatus: this.fatura.bankSliptStatus,
      faturaUrl: this.fatura.bankSliptUrl,
      title: this.fatura.title,
      value: this.fatura.value,      
      linhaDigitavel: detalhesFatura.linhaDigitavel,
      linhaDigitavelTratada: detalhesFatura.linhaDigitavelTratada,
      telefoneEscola: detalhesFatura.telefoneEscola,
      studentId: accessInfo.studentId,
      emailEscola: detalhesFatura.emailEscola,
      juros: detalhesFatura.juros,
      mora: detalhesFatura.mora
      
    };
  }

  getFatura(id: string): IFatura {
    const faturas = this.faturaService.getFaturasStored();
    return faturas.find((f) => f.bankSliptId == id) ?? this.emptyFatura;
  }

  public getFaturaDetails = async (fatura: IFatura): Promise<IFaturaDetalhadaAPI> => {
    return await firstValueFrom(this.faturaService.getFaturaDetails(fatura));
  };

  copyBarCode(e: Event): void {
    e.preventDefault();
    navigator.clipboard.writeText(this.faturaDetalhada.linhaDigitavelTratada);
    this.showFeedBackCopied();
    this.logCardDetail(this.fatura, 'COPIAR CÓDIGO');
  }

  setShowTicket(e: Event): void {
    e.preventDefault();
    this.showTicket = true
  }

  showFeedBackCopied(): void {
    this.copied = true;
    setTimeout(() => {
      this.copied = false;
    }, this.timeElapsed);
  }
}
